import React from "react";
import Grid from "@mui/material/GridLegacy";
import { ReadOnlyField, SubmitButton } from ".";
import { masks } from "../../utils";
import { StylesForm } from "../../pages/home/styles";

interface ValuesProps {
  fullName?: string;
  name?: string;
  docType?: number;
  docValue?: string;
  birthdayText?: string;
  email?: string;
  phone?: string;
  vehiclePlate?: string;
  number?: number;
}

interface Props {
  values: ValuesProps;
  showVehiclePlate?: boolean;
  onConfirm?: (v?: any) => void;
}

export default function ReadOnlyFieldsView({ values, showVehiclePlate = false, onConfirm }: Props) {
  const docType = values.docType ?? 1;
  const docValue = values.docValue ?? "";

  return (
    <StylesForm.HeaderSteps>
      <Grid container spacing={1}>
        <ReadOnlyField md={12} label="NOME COMPLETO" value={values.fullName ?? values.name} />
        <ReadOnlyField label="DOCUMENTO" value={docType === 1 ? masks.CPF(docValue) : docValue} />
        <ReadOnlyField label="DATA NASCIMENTO" value={values.birthdayText ?? "-"} />
        <ReadOnlyField label="E-MAIL" value={values.email} />
        {values.phone && (
          <ReadOnlyField label="TELEFONE" value={masks.inputMaskTELWithDDD(values.phone)} />
        )}
        {showVehiclePlate && values.vehiclePlate && (
          <ReadOnlyField label="PLACA DO VEÍCULO" value={values.vehiclePlate} />
        )}
        {typeof values.number !== "undefined" && (
          <ReadOnlyField label="Nº DE HÓSPEDES ACOMPANHANTES" value={values.number} />
        )}
      </Grid>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px", marginBottom: "16px" }}>
        <SubmitButton fullWidth={false} type="button" onClick={() => onConfirm && onConfirm(values)}>
          Confirmar
        </SubmitButton>
      </div>
    </StylesForm.HeaderSteps>
  );
}
